areaMembros.component('areaMembros.guiaEditComponent', {
    templateUrl: 'areaMembros/guiaEdit/guiaEdit.html',
    controller: 'areaMembros.guiaController',
    controllerAs: '$ctrl',
    bindings: { areaMembros: '<', idUsuario:'<' }
});

areaMembros.controller('areaMembros.guiaController', ['$scope', 'coreLanguage', '$state', 'coreFb', 'coreToast', '$filter', function($scope, $text, $state, $fb, $toast, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    const _getDominio=()=>{
        $fb.db.list('cad_faq', [{where:['criacao.idUsuario', '==', $ctrl.idUsuario]}]).then(list=>{
            $ctrl.faqs = list.map(item=>{
                return {
                    id: item.id,
                    nome:item.data.nome
                }
            });
        });
    };

    $ctrl.setViewForm=(value)=>{
        $ctrl.viewForm = value;
    };

    $ctrl.setViewFormBanner=(value)=>{
        $ctrl.viewFormBanner = value;
    };

    $ctrl.uploadBanner=(event, mobile=false)=>{

        const file = event.target.files[0]
        const ext = file.name.split('.').pop();

        if (!['png', 'jpg', 'jpeg', 'webp', 'svg'].includes(ext.toLowerCase())) {
            return
        }

        $ctrl.loadingFile=true;

        $fb.storage.upload(`/areaMembros/${$ctrl.areaMembros.id}/guia`, event.target.files[0]).then(url => {
            if(!$ctrl.areaMembros.data.guia){ $ctrl.areaMembros.data.guia = {}; }

            if(!mobile){
                $ctrl.areaMembros.data.guia.capaUrl = url;
            }else{
                $ctrl.areaMembros.data.guia.capaMobUrl = url;
            }

            $ctrl.loadingFile=false;
        });
    };

    $ctrl.updateBanner=()=>{
        $state.params.showGlobalLoading = true;
        
        $fb.db.update($ctrl.areaMembros.path, {
            'guia.capaUrl': $ctrl.areaMembros.data.guia.capaUrl,
            'guia.capaMobUrl': $ctrl.areaMembros.data.guia.capaMobUrl
        }).then(()=>{
            $ctrl.setViewFormBanner(false);
            $state.params.showGlobalLoading = false;
        });
    };
    
    $ctrl.updateArea=()=>{
        $state.params.showGlobalLoading = true;
        
        $fb.db.update($ctrl.areaMembros.path, {
            'guia.hypebot': $ctrl.areaMembros.data.guia.hypebot, 
            'guia.idFaq': $ctrl.areaMembros.data.guia.idFaq
        }).then(()=>{
            $ctrl.setViewForm(false);
            $state.params.showGlobalLoading = false;
        });
    };

    $ctrl.$onInit=()=>{
        $ctrl.idUsuario = $fb.auth.getIdToken().claims.idMaster || $fb.auth.getIdToken().claims.idUsuario;
        
        _getDominio();
    };

}]);